// src/api/vehiclesApi.js
import api from "./axios";

export async function getVehicleById(registrationNumber) {
  const { data } = await api.get(`/api/vehicles/${encodeURIComponent(registrationNumber)}`);
  return data; // { brand, model, color, ... }
}
